// @ts-nocheck
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../router-compat';
import { inject, observer } from "../../stores/mobx-compat";

import useLoginStore from '../../stores/loginStore';
import AuthShell from './AuthShell';
import {
  Field, PrimaryButton, MailIcon, LockIcon,
} from '../../components/ui';

const LoginPage = ({ store }) => {
  const {
    email, password, loading, error,
    setField, setLoading, setError, reset,
  } = useLoginStore();

  useEffect(() => () => reset(), [reset]);

  useEffect(() => {
    const { partner, hmac, shop, code } = store.initQueryParams;
    if (hmac && shop) {
      const currentUrl = new URL(window.location.href);
      store.auth.shopifyLogin(currentUrl.search);
    }
    if (partner === 'salesforcemarketingcloud' && code) {
      store.auth.salesforceMarketincCloudLogin(code);
    }
  }, [store]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await store.auth.login(email.trim(), password);
      const { partner = '', instance } = store.initQueryParams;
      if (partner.toLowerCase() === 'wix' && instance) {
        store.integrations.WiX.linkAccounts(instance);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Sign in"
      headline={(<>Welcome <em>back.</em></>)}
      lede="Pick up where you left off — campaigns, identities, and conversion windows are right where you left them."
    >
      <form onSubmit={onSubmit} autoComplete="on" noValidate>
        <Field
          label="Work email"
          name="email"
          type="email"
          value={email}
          onChange={setField}
          autoComplete="email"
          placeholder="you@company.com"
          icon={MailIcon}
        />

        <Field
          label="Password"
          name="password"
          type="password"
          value={password}
          onChange={setField}
          autoComplete="current-password"
          placeholder="Enter your password"
          icon={LockIcon}
          reveal
          rightLink={(
            <Link
              to="/forgot-password"
              className="text-[12px] text-mov-ink-soft no-underline border-b border-dotted border-mov-line-strong pb-px hover:border-mov-green hover:text-mov-green-ink"
            >
              Forgot?
            </Link>
          )}
          error={!!error}
        />

        {error && (
          <p className="text-[13px] mb-4 text-accent-red flex items-baseline gap-2 -mt-2">
            <span className="mono uppercase text-[10.5px]" style={{ letterSpacing: '0.14em' }}>Err</span>
            <span>{error}</span>
          </p>
        )}

        <PrimaryButton loading={loading}>Sign in to dashboard</PrimaryButton>

        <p className="mt-7 text-center text-mov-ink-soft text-[13.5px]">
          Don&apos;t have an account?{' '}
          <Link
            to="/register"
            className="text-mov-ink font-medium no-underline border-b border-mov-line-strong pb-px hover:border-mov-green hover:text-mov-green-ink"
          >
            Request access
          </Link>
        </p>
      </form>
    </AuthShell>
  );
};

export default withRouter(inject('store')(observer(LoginPage)));
